import { Stack } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';

import type { ReactElement, ReactNode } from 'react';

export type ReportLibraryListLayoutProps = {
  headerActions?: ReactElement;
  children: ReactNode;
};

/**
 * White card container for Report Library list views: header row (breadcrumb + actions)
 * and a slot for search controls, list metadata, report rows, and pagination.
 */
export function ReportLibraryListLayout({
  headerActions,
  children,
}: ReportLibraryListLayoutProps) {
  const { isMobile } = useScreenSize();
  return (
    <Stack
      spacing={3}
      sx={{
        width: '100%',
        bgcolor: 'background.paper',
      }}
    >
      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
      >
        {headerActions ? (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            flexShrink={0}
            width={'100%'}
            justifyContent={isMobile ? 'space-between' : 'flex-end'}
          >
            {headerActions}
          </Stack>
        ) : null}
      </Stack>
      <Stack spacing={3} sx={{ width: '100%', minWidth: 0 }}>
        {children}
      </Stack>
    </Stack>
  );
}
